import * as React from 'react';

import ApplicationCancelContainer from '../../containers/ApplicationCancel';
import MainMenu from '../../containers/MainMenu';
import Navbar from '../../containers/Navbar';
import i18n from '../../resources/i18n';
/**
 *
 * @param props 申請取消画面
 */
const ApplicationCancel: React.FC<any> = props => {
	return (
		<>
			<MainMenu />
			<Navbar title={i18n.t('ApplicationCancel_0013')} />
			<ApplicationCancelContainer {...props} />
		</>
	);
};

export default ApplicationCancel;



// WEBPACK FOOTER //
// ./src/pages/personal/ApplicationCancel.tsx